import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { DataBaseService} from '../services/data-base.service';
import {Router} from '@angular/router';
import * as firebase from 'firebase';
import { Subscription } from 'rxjs/Subscription';


@Component({
  selector: 'auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

authStatus: boolean;
emailUser:string="";
passwordUser:string="";
userNotFound = false;
userNotFoundSubscription:Subscription;

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    firebase.auth().onAuthStateChanged(
      (user) => {
        if(user) {
          this.authStatus = true;
          this.router.navigate(['admin-home']);
        } else {
          this.authStatus = false;
        }
      }
    );
    
    this.userNotFoundSubscription = this.authService.userNotFoundSubject.subscribe((userNotFound) => {
    this.userNotFound = userNotFound;
    });
  }

 SignIn(form:any) {
    if(form){
        this.authService.signInUser(form.email,form.password);
    }
 }

}
